import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "@/App";
import { Navbar } from "@/components/Navbar";
import { ProjectCard } from "@/components/ProjectCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Download, Package } from "lucide-react";

export default function MyDownloadsPage() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = async () => {
    try {
      const response = await axios.get(`${API}/user/purchases`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPurchases(response.data);
    } catch (error) {
      console.error('Failed to fetch purchases:', error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <main className="max-w-5xl mx-auto px-4 md:px-8 py-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-orange-500/20 rounded-lg flex items-center justify-center">
            <Download className="w-6 h-6 text-orange-500" />
          </div>
          <div>
            <h1 className="font-rajdhani font-bold text-2xl text-gray-800">
              मेरे डाउनलोड्स
            </h1>
            <p className="text-sm text-gray-8000">आपके खरीदे गए प्रोजेक्ट्स</p>
          </div>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 gap-4">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} className="h-40 bg-white" />
            ))}
          </div>
        ) : purchases.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-xl border border-gray-200">
            <Package className="w-16 h-16 text-slate-700 mx-auto mb-4" />
            <h3 className="text-xl text-gray-500 mb-2">अभी कोई खरीदारी नहीं</h3>
            <p className="text-gray-8000 mb-6">
              प्रोजेक्ट्स देखें और अपनी पसंद की रिपोर्ट खरीदें
            </p>
            <button
              onClick={() => navigate('/')}
              className="btn-primary rounded-sm px-8 py-3"
            >
              प्रोजेक्ट्स देखें
            </button>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4" data-testid="purchases-grid">
            {purchases.map((project, index) => (
              <ProjectCard key={project.id} project={project} index={index} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
